import moment from 'moment-timezone';

const LILATE_CANCELLATION_MIN_NOTICE_HOURS = 24;

/**
 * Délai d'annulation / report d'un LILATE par le candidat.
 *
 * Le délai est glissant : l'action reste possible tant qu'il reste au moins
 * 24 heures avant le début du passage. Pour un examen le 03/01 à 10h00, elle est
 * possible jusqu'au 02/01 à 10h00 inclus, puis refusée.
 *
 * Le backend applique la même règle et reste la source de vérité
 * (Lilate.can_be_cancelled_by_student).
 *
 * @returns true si le candidat ne peut plus annuler ni reporter son passage.
 */
export function isLilateCancellationLocked(
  start: string | Date | null | undefined,
  now: moment.Moment = moment()
): boolean {
  if (!start) {
    return false;
  }
  return moment(now).add(LILATE_CANCELLATION_MIN_NOTICE_HOURS, 'hours').isAfter(moment(start));
}
